
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CustomMaterialModule } from './core/material.module';

import { DataTablesModule } from 'angular-datatables';

import { AppRoutingModule, routingComponents } from './app-routing.module';
import { AppComponent } from './app.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { NgxFileDropModule } from 'ngx-file-drop';

import { NavigationComponent } from './navigation/navigation.component';

import { SweetAlert2Module } from '@toverux/ngx-sweetalert2';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { HttpAuthInterceptor } from './http-auth-interceptor';
import { AuthService } from './servicios/auth.service';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { DynamicFormContenidoComponent } from './dynamic-form-contenido/dynamic-form-contenido.component';
import { CreacionusuariosComponent } from './creacionusuarios/creacionusuarios.component';
import { CrearPersonaComponent } from './creacionusuarios/crear-persona/crear-persona.component';
import { CrearUsuarioComponent } from './creacionusuarios/crear-usuario/crear-usuario.component';
import { ConsultarPersonaComponent } from './creacionusuarios/consultar-persona/consultar-persona.component';
import { ConsultaPersonaComponent } from './creacionusuarios/consulta-persona/consulta-persona.component';
import { CreacionpersonaComponent } from './creacionusuarios/creacionpersona/creacionpersona.component';
import { CreacionusuarioComponent } from './creacionusuarios/creacionusuario/creacionusuario.component';
import { ReportePersonasComponent } from './creacionusuarios/reporte-personas/reporte-personas.component';
import { UsuarioComponent } from './usuario/usuario.component';

import { Myfilterpipe } from './utils/myfilterpipe';
import {
  MAT_DATE_LOCALE,
  DateAdapter,
  MAT_DATE_FORMATS
} from '@angular/material/core';
import { ModificausuarioComponent } from './modificausuario/modificausuario.component';
import { DynamicReportComponent } from './dynamic-report/dynamic-report.component';
import { DynamicReportContenidoComponent } from './dynamic-report-contenido/dynamic-report-contenido.component';
import { GestionMaestrasComponent } from './gestion-maestras/gestion-maestras.component';
import { AsignacionServiciosComponent } from './asignacion-servicios/asignacion-servicios.component';
import { ServiciosasignadosComponent } from './serviciosasignados/serviciosasignados.component';
import { AdministracionConductoresComponent } from './administracion-conductores/administracion-conductores.component';
import { AdministracionCausalesNoEntregaComponent } from './administracion-causales-no-entrega/administracion-causales-no-entrega.component';
import { AdministracionMotivoDevolucionComponent } from './administracion-motivo-devolucion/administracion-motivo-devolucion.component';
import { AdministracionEmpresaTransporteComponent } from './administracion-empresa-transporte/administracion-empresa-transporte.component';
import { AdministracionUsuarioWebComponent } from './administracion-usuario-web/administracion-usuario-web.component';
import { AdministracionMensajesComponent } from './administracion-mensajes/administracion-mensajes.component';
import { EntregasCompletasComponent } from './entregas-completas/entregas-completas.component';
import { EntregasParcialesComponent } from './entregas-parciales/entregas-parciales.component';
import { EntregasComponent } from './entregas/entregas.component';
import { TiemposRutasComponent } from './tiempos-rutas/tiempos-rutas.component';
import { RutaEntregasComponent } from './ruta-entregas/ruta-entregas.component';
import { UbicacionComponent } from './ubicacion/ubicacion.component';
import { DialogEditPersonaComponent } from './dialogs/dialog-edit-persona/dialog-edit-persona.component';
import { ModificarDireccionPersonaComponent } from './creacionusuarios/modificar-direccion-persona/modificar-direccion-persona.component';
import { ModificarUsuarioPersonaComponent } from './creacionusuarios/modificar-usuario-persona/modificar-usuario-persona.component';
import { DialogCopiarEncuestaComponent } from './dialogs/dialog-copiar-encuesta/dialog-copiar-encuesta.component';
import { ServicioComponent } from './servicio/servicio.component';
import { CrearServicioComponent } from './servicio/crear-servicio/crear-servicio.component';
import { ModificarServicioComponent } from './servicio/modificar-servicio/modificar-servicio.component';
import { CreacionPaqueteComponent } from './servicio/creacion-paquete/creacion-paquete.component';
import { ModificarPaqueteComponent } from './servicio/modificar-paquete/modificar-paquete.component';
import { from } from 'rxjs';
import { DialogDocumentoComponent } from './dialogs/dialog-documento/dialog-documento.component';
import { DialogProductoComponent } from './dialogs/dialog-producto/dialog-producto.component';
import { DialogFirmaComponent } from './dialogs/dialog-firma/dialog-firma.component';
import { DialogWebServiceComponent } from './dialogs/dialog-web-service/dialog-web-service.component';

import { VerticalTimelineModule } from 'angular-vertical-timeline';
import { AdministracionAgenciaComponent } from './administracion-agencia/administracion-agencia.component';
import { AsignacionTransportadorAgenciaComponent } from './asignacion-transportador-agencia/asignacion-transportador-agencia.component';
import { AsignacionTransportadorVehiculoComponent } from './asignacion-transportador-vehiculo/asignacion-transportador-vehiculo.component';
import { AdministracionTiposNovedadesComponent } from './administracion-tipos-novedades/administracion-tipos-novedades.component';
import { AdministracionMotivosComponent } from './administracion-motivos/administracion-motivos.component';
import { MotivosComponent } from './administracion-motivos/motivos/motivos.component';
import { TipoMotivoComponent } from './administracion-motivos/tipo-motivo/tipo-motivo.component';
import { TipoMotivoClasComponent } from './administracion-motivos/tipo-motivo-clas/tipo-motivo-clas.component';
import { DialogAgenciasComponent } from './dialogs/dialog-agencias/dialog-agencias.component';
import { EntregasTransportadorComponent } from './entregas-transportador/entregas-transportador.component';
import { CarguesUsuarioComponent } from './cargues-usuario/cargues-usuario.component';
import { MglTimelineModule } from 'angular-mgl-timeline';
import { FilterPipe } from './pipes/filter.pipe';
import { DialogoGestionCargueComponent } from './dialogs/dialogo-gestion-cargue/dialogo-gestion-cargue.component';
import { DialogoEntregaNuevaComponent } from './dialogs/dialogo-entrega-nueva/dialogo-entrega-nueva.component';




@NgModule({
  declarations: [
    AppComponent,
    NavigationComponent,
    routingComponents,
    DynamicFormComponent,
    DynamicFormContenidoComponent,
    CreacionusuariosComponent,
    CrearPersonaComponent,
    CrearUsuarioComponent,
    ConsultarPersonaComponent,
    ConsultaPersonaComponent,
    CreacionpersonaComponent,
    CreacionusuarioComponent,
    ReportePersonasComponent,
    UsuarioComponent,
    Myfilterpipe,
    ModificausuarioComponent,
    DynamicReportComponent,
    DynamicReportContenidoComponent,
    GestionMaestrasComponent,
    AsignacionServiciosComponent,
    ServiciosasignadosComponent,
    AdministracionConductoresComponent,
    AdministracionCausalesNoEntregaComponent,
    AdministracionMotivoDevolucionComponent,
    AdministracionEmpresaTransporteComponent,
    AdministracionUsuarioWebComponent,
    AdministracionMensajesComponent,
    EntregasCompletasComponent,
    EntregasParcialesComponent,
    EntregasComponent,
    TiemposRutasComponent,
    RutaEntregasComponent,
    UbicacionComponent,
    DialogEditPersonaComponent,
    ModificarDireccionPersonaComponent,
    ModificarUsuarioPersonaComponent,
    DialogCopiarEncuestaComponent,
    ServicioComponent,
    CrearServicioComponent,
    ModificarServicioComponent,
    CreacionPaqueteComponent,
    ModificarPaqueteComponent,
    DialogDocumentoComponent,
    DialogProductoComponent,
    DialogFirmaComponent,
    DialogWebServiceComponent,
    AdministracionAgenciaComponent,
    AsignacionTransportadorAgenciaComponent,
    AsignacionTransportadorVehiculoComponent,
    AdministracionTiposNovedadesComponent,
    AdministracionMotivosComponent,
    MotivosComponent,
    TipoMotivoComponent,
    TipoMotivoClasComponent,
    DialogAgenciasComponent,
    EntregasTransportadorComponent,
    CarguesUsuarioComponent,
    FilterPipe,
    DialogoGestionCargueComponent,
    DialogoEntregaNuevaComponent,
  ],
  entryComponents: [
    DialogEditPersonaComponent,
    DialogCopiarEncuestaComponent,
    DialogDocumentoComponent,
    DialogWebServiceComponent,
    DialogAgenciasComponent,
    DialogoGestionCargueComponent,
    DialogoEntregaNuevaComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    CustomMaterialModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxFileDropModule,
    DataTablesModule,
    SweetAlert2Module.forRoot({
      buttonsStyling: false,
      customClass: 'modal-content',
      confirmButtonClass: 'btn btn-primary',
      cancelButtonClass: 'btn'
    }),
    NgScrollbarModule,
    VerticalTimelineModule,
    MglTimelineModule
  ],
  providers: [
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpAuthInterceptor,
      multi: true
    },
    { provide: MAT_DATE_LOCALE, useValue: 'es-CO' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
